import { Input } from 'antd';
import { Radio } from 'antdV3';
import { COLOR_OPTIONS } from 'config/style/color-options';
import styled from 'styled-components';

export const SeasonPopoverTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SeasonPopoverTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  svg {
    color: #0071cd !important;
  }
`;

export const SeasonPopoverContainer = styled.div<{ $disabled?: boolean; $active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  padding: 4px 16px;
  border-radius: 100px;
  border: 2px solid ${({ $active }) => ($active ? COLOR_OPTIONS.BLUE_30 : COLOR_OPTIONS.NEUTRAL_10)};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  background-color: ${({ $disabled, $active }) => {
    if ($active) {
      return COLOR_OPTIONS.BLUE_10;
    }
    return $disabled ? COLOR_OPTIONS.NEUTRAL_20 : 'transparent';
  }};
  transition: border-color 300ms ease-in-out, background-color 300ms ease-in-out;

  &:hover {
    border-color: ${({ $active }) => ($active ? COLOR_OPTIONS.BLUE_30 : 'rgb(223, 226, 231)')};
  }

  > svg {
    transform: ${({ $active }) => ($active ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 300ms ease-in-out;
  }
`;

export const SeasonPopoverFooter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: space-between;
`;

export const SeasonPopoverHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  .antdV3-switch-checked {
    background-color: #0071cd;
  }
`;

export const SeasonPopoverBody = styled.div`
  width: 312px;
  padding: 8px;
`;

export const SeasonListContainer = styled.div`
  overflow: auto;
  max-height: 35vh;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 0px 0px 8px 0px;
`;

export const BlueRadioGroup = styled(Radio.Group)`
  .antdV3-radio-checked::after {
    border: 1px solid ${COLOR_OPTIONS.BLUE_60} !important;
    background: ${COLOR_OPTIONS.BLUE_60} !important;
  }

  .antdV3-radio-inner::after {
    background-color: ${COLOR_OPTIONS.BLUE_60} !important;
  }
  .antdV3-radio-checked .antdV3-radio-inner {
    border-color: ${COLOR_OPTIONS.BLUE_60};
  }
`;

export const SeasonPopoverSearch = styled(Input)`
  border: none;
  background-color: transparent;
  border-bottom: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
  border-radius: 0px;
`;
